'use client'

import { useMemo, useState } from "react"
import BranchCard from "./BranchCard"
import { ChevronRight, MapPinHouse, Search } from 'lucide-react'
import { resolveColorHex, getVendorPrimaryColor } from "@/utils/util"
import EmptyState from "@/components/elements/EmptyState"

export default function BranchList({ branches, vendor }: { branches: any, vendor?: any }) {
  const primary = resolveColorHex(getVendorPrimaryColor(vendor))
  const [query, setQuery] = useState('')

  const filtered = useMemo(() => {
    const list = (branches || []).filter((b: any) => b?.isActive !== false)
    if (!query.trim()) return list
    const q = query.trim().toLowerCase()
    return list.filter((b: any) =>
      [b.name, b.address, b.phone].filter(Boolean).some((v: string) => v.toLowerCase().includes(q))
    )
  }, [branches, query])

  return (
    <div className="bg-white">
      <div className="mx-auto w-full max-w-320 px-4 lg:px-8 py-8">
        <div className="flex items-center gap-1.5 text-[12px] text-muted-foreground mb-8">
          <a href="/" className="hover:text-foreground">Нүүр</a>
          <ChevronRight className="h-3 w-3" />
          <span className="text-foreground font-medium">Салбарууд</span>
        </div>

        <div className="flex items-end justify-between gap-6 flex-wrap mb-8">
          <div>
            <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground">
              Бидний салбарууд
            </h1>
            {filtered.length > 0 && (
              <p className="mt-2 text-sm text-muted-foreground max-w-xl">
                {filtered.length} байршилд үйлчилж байна. Танд хамгийн ойрхон салбарыг сонгон орж үзээрэй.
              </p>
            )}
          </div>
          {(branches?.length || 0) > 3 && (
            <div className="flex items-center h-10 px-3.5 gap-2 rounded-full bg-muted border-2 border-transparent focus-within:bg-white focus-within:border-(--brand) transition-colors w-full sm:w-64" style={{ ['--brand' as any]: primary }}>
              <Search className="h-4 w-4 text-muted-foreground shrink-0" />
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Салбар хайх..."
                className="flex-1 bg-transparent border-0 outline-none text-sm focus:outline-none focus:ring-0 focus:border-0 placeholder:text-muted-foreground"
              />
            </div>
          )}
        </div>

        {filtered.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {filtered.map((branch: any, index: number) => (
              <BranchCard key={branch.id} branch={branch} vendor={vendor} index={index} />
            ))}
          </div>
        ) : (
          <EmptyState
            icon={MapPinHouse}
            primary={primary}
            title={query ? 'Илэрц олдсонгүй' : 'Салбарын мэдээлэл хоосон байна'}
            description={query ? '"' + query + '" гэсэн нэртэй салбар олдсонгүй. Өөр түлхүүр үг ашиглан дахин хайна уу.' : 'Яг одоогоор салбарын мэдээлэл байхгүй байна. Хэсэг хугацааны дараа дахин шалгана уу.'}
          />
        )}
      </div>
    </div>
  )
}
